function initCardSlider(slider) {
  const track = slider.querySelector('.card-slider__track');
  const slides = slider.querySelectorAll('.card-slide');
  const prev = slider.querySelector('.card-slider__arrow--prev');
  const next = slider.querySelector('.card-slider__arrow--next');
  const dots = slider.querySelectorAll('.card-slider__dot');
  let current = 0;

  if (!track || slides.length <= 1) return;

  function getSlideWidth() {
    return slider.offsetWidth;
  }

  function setTrackPosition(x, animated = true) {
    track.style.transition = animated
      ? 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
      : 'none';
    track.style.transform = `translateX(${x}px)`;
  }

  function updateArrows() {
    if (prev) {
      const isFirst = current === 0;
      prev.classList.toggle('is-disabled', isFirst);
      prev.style.pointerEvents = isFirst ? 'auto' : '';
    }
    if (next) {
      const isLast = current === slides.length - 1;
      next.classList.toggle('is-disabled', isLast);
      next.style.pointerEvents = isLast ? 'auto' : '';
    }
  }

  function goTo(index) {
    current = Math.max(0, Math.min(index, slides.length - 1));
    setTrackPosition(-(current * getSlideWidth()));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    updateArrows();
  }

  // Init dots
  if (dots[0]) dots[0].classList.add('is-active');
  updateArrows();

  dots.forEach((dot, i) => {
    dot.addEventListener('click', e => { e.preventDefault(); goTo(i); });
  });

  prev?.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    if (!prev.classList.contains('is-disabled')) goTo(current - 1);
  });

  next?.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    if (!next.classList.contains('is-disabled')) goTo(current + 1);
  });

  // --- DRAG NATIF ---
  let startX = 0;
  let startY = 0;
  let isDraggingHorizontal = false;
  let hasSwiped = false;
  const SWIPE_THRESHOLD = 40;

  slider.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDraggingHorizontal = false;
    hasSwiped = false;
    track.style.transition = 'none';
  }, { passive: true });

  slider.addEventListener('touchmove', (e) => {
    const dx = e.touches[0].clientX - startX;
    const dy = e.touches[0].clientY - startY;

    if (!isDraggingHorizontal && Math.abs(dx) < 5 && Math.abs(dy) < 5) return;

    if (!isDraggingHorizontal) {
      if (Math.abs(dx) > Math.abs(dy)) {
        isDraggingHorizontal = true;
      } else {
        return;
      }
    }

    e.preventDefault();
    hasSwiped = true;

    const isAtStart = current === 0 && dx > 0;
    const isAtEnd = current === slides.length - 1 && dx < 0;
    const resistance = (isAtStart || isAtEnd) ? 0.2 : 1;
    const baseX = -(current * getSlideWidth());

    track.style.transform = `translateX(${baseX + dx * resistance}px)`;
  }, { passive: false });

  slider.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - startX;

    if (isDraggingHorizontal && Math.abs(dx) > SWIPE_THRESHOLD) {
      goTo(current + (dx < 0 ? 1 : -1));
    } else {
      setTrackPosition(-(current * getSlideWidth()));
    }

    isDraggingHorizontal = false;
  });

  slider.addEventListener('click', (e) => {
    if (hasSwiped) {
      e.preventDefault();
      e.stopPropagation();
      hasSwiped = false;
    }
  }, true);

  // --- SWATCHES ---
  const cardWrapper = slider.closest('.card-wrapper, [data-product-id], .card');
  if (cardWrapper) {
    cardWrapper.querySelectorAll('[data-card-swatch]').forEach(swatch => {
      swatch.addEventListener('click', () => {
        const src = swatch.dataset.variantImageSrc;
        const srcset = swatch.dataset.variantImageSrcset;
        if (!src) return;
        const firstSlide = slides[0];
        const img = firstSlide?.querySelector('img');
        if (img) {
          img.src = src;
          if (srcset) img.srcset = srcset;
        }
        goTo(0);
      });
    });
  }
}

// ─── Init au chargement de la page ───────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-card-slider]').forEach(initCardSlider);
});

// ─── Init après injection des produits connexes ───────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const productRecs = document.querySelector('product-recommendations');
  if (!productRecs) return;

  const observer = new MutationObserver(() => {
    productRecs.querySelectorAll('[data-card-slider]').forEach(slider => {
      if (!slider.dataset.sliderInit) {
        slider.dataset.sliderInit = 'true';
        initCardSlider(slider);
      }
    });
  });

  observer.observe(productRecs, { childList: true, subtree: true });
});
